const CACHE_KEYS = {
  TRANSMISSION_TYPE: ["transmission_types"],
  GEO_SCOPE: ["geo_scope"],
  SPECIALIZATIONS: ["specializations"],
  BUSINESS_TYPES: ["business-types"],
  COMMISSION_SETTING: ["commission-settings"],
  COMMISSIONS: ["commissions"],
  // CATTLE_BREEDS
  CATTLE_BREEDS: ["cattle_breeds"],
  SINGLE_CATTLE_BREEDS: ["single_cattle_breeds"],
  WORK_TYPES: ["worker-types"],
  CATTLE_TYPES: ["cattle-types"],
  SINGLE_CATTLE_TYPES: ["single-cattle-types"],
  //TRAVEL_MODES
  TRAVEL_MODES: ["travel_modes"],
  //CURRENCIES
  CURRENCIES: ["currencies"],
  //CLAIM_SETTLEMENT_TYPE
  CLAIM_SETTLEMENT_TYPE: ["claim_settlement_type"],
  //CLAIM_TYPE_FIELD
  CLAIM_TYPE_FIELD: ["claim_type_fields"],
  //CLAIM_TEMPLATE
  CLAIM_TEMPLATE: ["claim_template"],
  CLAIM_TEMPLATES: ["claim_templates"],
  //CLAIM-TEMPLATE-FIELDS
  CLAIM_TEMPLATE_FIELDS: ["claim_template_fields"],
  //COUPONS
  COUPONS: ["coupons"],
  ENTITIES: ["entities"],
  // CARD_TYPES
  CARD_TYPES: ["card_types"],
  //CARDS
  CARDS: ["cards"],
  SPECIES: ["species"],
  //Partner Role
  PARTNER_ROLE: ["partner_role"],
  // Partners
  PARTNERS: ["partners"],
  // Role
  ROLES: ["roles"],
  // Payment Master
  PAYMENT_MASTER: ["payment_master"],
  // payment mode
  PAYMENT_MODE: ["payment_mode"],
  // ITEMS
  ITEMS: ["items"],
  //Products
  PRODUCTS: ["products"],
  SINGLE_PRODUCT: ["single_product"],
  // State
  STATE: ["state"],

  //Branches
  BRANCHES: ["branches"],

  //Relations
  RELATIONS: ["relations"],
  // Gender
  GENDER: ["gender"],
  //Api Token
  API_TOKENS: ["api_tokens"],
  // Auth User
  AUTH_USER: ["auth_user"],
  // City
  CITY: ["cities"],
  // Fire Coverages
  PROPERTY_COVERAGES: ["property_coverages"],
  //Cancellation Reasons
  CANCELLATION_REASONS: ["cancellation_reasons"],
  // Loading
  LOADING: ["loading"],
  // Product Types
  PRODUCT_TYPES: ["product_types"],
  ALERT: ["alert"],
  // Pincode
  PINCODES: ["pincodes"],
  // Premium Types
  RATERS: ["raters"],
  // USERS
  USERS: ["users"],
  // Nature of business
  NATURE_OF_BUSINESS: ["nature_of_business"],
  PARTNER_USERS: ["partner_users"],
  // BANK BRANCHES
  BANK_BRANCHES: ["bank_branches"],
  // THEME
  THEMES: ["themes"],
  // Partner Branches
  PARTNER_BRANCHES: ["partner_branches"],
  //Partner Customer
  PARTNER_CUSTOMER: ["partner_customer"],
  //Declaration
  DECLARATIONS: ["declarations"],
  //Policies
  POLICIES: ["policies"],
  LEADS: ["leads"],
  SINGLE_LEAD: ["single_lead"],
  //Certificate Templates
  CERTIFICATE_TEMPLATES: ["certificate_templates"],
  // Alert templates
  ALERT_TEMPLATES: ["alert_templates"],
  // Default ALert Template
  DEFAULT_ALERT_TEMPLATE: ["default_templates"],
  // Plans
  PLANS: ["plans"],
  // Combos
  COMBOS: ["combos"],
  // Single Plan
  SINGLE_PLAN: ["single_plan"],

  CASH_DEPOSITS: ["cash_deposits"],
  // Frontend Boot
  FRONTEND_BOOT: ["frontend_boot"],
  // Partner Frontend Boot
  PARTNER_FRONTEND_BOOT: ["partner_frontend_boot"],
  // Accounts
  ACCOUNTS: ["accounts"],
  // Accounts
  TRANSACTIONS: ["transactions"],
  //Features
  FEATURES: ["features"],
  //Occupations
  OCCUPATIONS: ["occupations"],
  FEATURE_CATEGORIES: ["feature_categories"],
  // Partner Link
  JOURNEYS: ["journeys"],
  SEGMENTS: ["segments"],
  SUBSEGMENTS: ["subsegments"],
  //Certificates
  CERTIFICATES: ["PartnerCertificates"],
  CERTIFICATES_PREMIUM_COUNT: ["certificatePremiumCount"],
  CERTIFICATES_AVERAGE_PREMIUM_COUNT: ["certificateAveragePremiumCount"],
  CERTIFICATES_STAGES: ["CertificateStages"],

  // Webhooks
  WEBHOOKS: ["webhooks"],

  // IC Api Config
  IC_API_CONFIG: ["icApiConfig"],

  // Upload Certificates
  UPLOAD_CERTIFICATES: ["uploadCertificateDataLogs"],
  //Enquiry Stages
  ENQUIRY_STAGES: ["EnquiryStages"],
  //Partner Regions
  PARTNER_REGIONS: ["partnerRegions"],
  //Zones
  ZONES: ["Zones"],
  // Breeds
  BREEDS: ["breeds"],
  // Countries
  COUNTRIES: ["countries"],
  // Activity
  ACTIVITY: ["activities"],
  // Payment Gateways
  PAYMENT_GATEWAYS: ["payment_gateways"],
  // Singe Partner
  SINGLE_PARTNER: ["single_partner"],
  // Reports
  REPORTS: ["reports"],
  // Loader File
  LOADER_FILE: ["loader_file"],
  // Data Sources
  DATA_SOURCES: ["data_sources"],
  // Inco Terms
  INCO_TERMS: ["incoterms"],
  //Packaging Type
  PACKAGING_TYPES: ["packaging_types"],
  //Event Type
  EVENT_TYPES: ["event_types"],
  // Dashboard
  DASHBOARD: ["dashboards"],
  // Riders
  RIDERS: ["riders"],
  // COMMODITY
  COMMODITY: ["commodity"],
  // Occupancy type
  OCCUPANCY_TYPE: ["occupancy_types"],
  //Credentials
  CREDENTIALS: ["credentials"],
  // Gadgets
  GADGETS: ["gadgets"],
  SINGLE_CERTIFICATE: ["single_certificate"],

  //Knockout Questions
  KNOCKOUT_QUESTIONS: ["knockout_questions"],
  //Questions
  QUESTIONS: ["questions"],
  // Blocked ares
  BLOCKED_LOCATIONS: ["blocked_locations"],
  LANDING_PAGES: ["landing_pages"],

  //Executive signals
  EXECUTIVE_SIGNALS: ["executive_signals"],
  //notification_dashboard
  NOTIFICATION_CENTER: ["notification-dashboard"],

  //Enquiry
  ENQUIRIES: ["journey_enquiry"],
  ENQUIRY: ["enquiries"],
  JOURNEY_FRONTEND_BOOT: ["journey_frontend_boot"],
  LANDING_PAGE: ["broker-landing-page"],

  // Claims
  CLAIMS: ["claims"],
  CLAIMS_EXPENSE: ["claim_expenses"],
  CLAIM_TYPES: ["claim-types"],
  CLAIM_STAGES: ["claim-stages"],
  CLAIM_DASHBOARD: ["claim-dashboards"],
  CONFIGURED_CLAIMS: ["configured-claims"],
  //Endorsements
  ENDORSEMENTS: ["endorsements"],

  //Covers
  COVERS: ["covers"],

  //Alert logs
  ALERT_LOGS: ["alert_logs"],

  // Cancellation Reas
  CANCELLATION_REASON: ["cancellation-reason"],

  //Product Claim Template
  PRODUCT_CLAIM_TEMPLATE: ["product-claim-template"],

  //Critical Illnesses
  CRITICALILLNESSES: ["critical-illnesses"],

  //Dummy
  DUMMYRESPONSE: ["dummy_response"],

  // Partner Token Generation
  GENERATE_PARTNER_TOKEN: ["generate-partner-token"],

  //Prefilled Data
  PREFILLED_DATA: ["prefilled-data"],

  // captcha
  CAPTCHA: ["captcha"],
  MANUFACTURER: ["MANUFACTURER"],
  FUEL_TYPES: ["FUEL_TYPES"],
  VARIANT: ["VARIANT"],
  MODEL: ["MODEL"],
  INSURERS: ["INSURERS"],
  INSURER: ["INSURER"],
  CONSENT: ["CONSENTS"],
  CERTIFICATE_CANCELLATION_FORMAT: ["downloadCertificateCancellationFormat"],
  CERTIFICATE_DELETION_FORMAT: ["downloadCertificateDeletionFormat"],
  BULK_CERTIFICATE_CANCEL_LOGS: ["certificate-bulk-cancel-logs"],
  BULK_CERTIFICATE_DELETE_LOGS: ["certificate-bulk-delete-logs"],
};
export { CACHE_KEYS };
